import { render, staticRenderFns } from "./carInfo.vue?vue&type=template&id=7953bf9e&scoped=true&"
import script from "./carInfo.vue?vue&type=script&lang=js&"
export * from "./carInfo.vue?vue&type=script&lang=js&"
import style0 from "./carInfo.vue?vue&type=style&index=0&id=7953bf9e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7953bf9e",
  null
  
)

export default component.exports